const INCREMENT = 'INCREMENT' // 增加
const DECREMENT = 'DECREMENT' // 减少
const INCREMENT_IF_ODD = 'INCREMENT_IF_ODD'
const INCREMENT_ASYNC = 'INCREMENT_ASYNC'
const INCREMENT_ASYNC_ONCE = 'INCREMENT_ASYNC_ONCE'
export {
  INCREMENT,
  INCREMENT_IF_ODD,
  DECREMENT,
  INCREMENT_ASYNC,
  INCREMENT_ASYNC_ONCE
}



// WEBPACK FOOTER //
// ./src/const/actions.js